module.exports = __webpack_public_path__ + "img/badge-list-thumb-094.1df9070c.png";